import { Component, OnInit} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AssetService } from '../../services/asset-service';
import { ActivatedRoute } from '@angular/router';
import { AssetPipe } from '../../pipes/asset-pipe';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { Asset } from 'src/app/assabil-kernel/models/entities/master-data/asset';
 

@Component({
    selector: 'asset-list-mobile',
    templateUrl: './asset-list-mobile.component.html',
    styleUrls: ['./asset-list-mobile.component.scss']
})

export class AssetListMobileComponent implements OnInit {

  assets               : Asset[]= []; 
  currentAsset         : Asset = null;

  assetTransferCode   : string;


  constructor(
    protected assetService      : AssetService,
    protected toastr            : ToastrService,
    protected leanUtilsService  : LeanUtilsService,
    protected networkService    : LeanNetworkService,
    protected activatedRoute    : ActivatedRoute,) {
  }

  assetPipe               : AssetPipe = new AssetPipe();
  listFields = [
    { prop: 'serialNumber',         name: 'N° serie',      style: {'font-weight': 'bold', 'font-style': 'italic'}   },
    { prop: 'barCode',              name: 'Code à barres',  pipe : this.assetPipe},
    { prop: 'assignmentStats',      name: 'Statut' },
    { prop: 'product.name',         name: 'Produit' },
  ]


ngOnInit(){

  //this.assetTransferCode = assetTransferCode;
          
  let assetCode        : string   = null;
  let withLinkedData   : boolean  = false;
  let assetOrderCode   : string   = null;
  let branchCode       : string   = null;
  let assetTransferCode: string   = null;
  let partnerCode      : string   = null;
  let partnerSiteCode  : string   = null;
  let assetStatusCode  : string   = null;


this.assetService.assetsGet(  assetCode            ,
                              withLinkedData       ,
                              assetOrderCode       ,
                              branchCode           ,
                              partnerCode          ,
                              partnerSiteCode      ,
                              assetStatusCode      ,
                              assetTransferCode    ).then(result => {
      this.assets = result;
})
}

  selectRow(asset : Asset){
    this.currentAsset = asset;
  }

}
